import React from 'react';
import './BackToTop.css';

// Atalho para voltar ao início da página, usado entre as seções de departamento
// da página principal. Respeita quem prefere menos animação no sistema.
export default function BackToTop({ className = '' }) {
  const voltarAoTopo = () => {
    const semAnimacao = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: semAnimacao ? 'auto' : 'smooth' });
  };

  return (
    <div className={`back-to-top ${className}`.trim()}>
      <button type="button" onClick={voltarAoTopo}
        className="back-to-top-btn" title="Voltar ao topo da página"
        aria-label="Voltar ao topo da página">
        <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M8 3.5a.5.5 0 0 1 .354.146l4 4a.5.5 0 0 1-.708.708L8 4.707 4.354 8.354a.5.5 0 1 1-.708-.708l4-4A.5.5 0 0 1 8 3.5"/>
          <path d="M8 7.5a.5.5 0 0 1 .354.146l4 4a.5.5 0 0 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 0 1-.708-.708l4-4A.5.5 0 0 1 8 7.5"/>
        </svg>
        <span>Voltar ao topo</span>
      </button>
    </div>
  );
}
